// Client copy of EasyParcel status labels — mirrors
// server/src/common/constants/easyparcel-status.ts
export const EP_STATUS_LABELS: Record<string, string> = {
  '0': 'Cancelled',
  '2': 'To Be Collected',
  '3': 'Collected',
  '4': 'In Transit',
  '5': 'Delivered',
  '6': 'Returned',
  '7': 'Schedule In Arrangement',
  '8': 'On Hold',
  '11': 'Drop Off',
}
